function normalizeObjectKeyGameList(list) {
    // ถ้า list ไม่ใช่ array → แทนด้วย []
    const arr = Array.isArray(list) ? list : [];

    const onlyGames = arr.map(it => it?.game).filter(Boolean);
    const valid = onlyGames.filter(
        g => typeof g?.id === "number" || typeof g?.id === "string"
    );

    const seen = new Set();
    return valid.filter(g => {
        if (seen.has(g.id)) return false;
        seen.add(g.id);
        return true;
    });
}

function createLikeIndex(likeList = [], { match = 'loose' } = {}) {
    const idSet = new Set();
    const keySet = new Set(); // camp|code (lowercase)

    for (const g of Array.isArray(likeList) ? likeList : []) {
        if (g?.id != null) idSet.add(Number(g.id));
        if (g?.camp && g?.code) {
            keySet.add(`${String(g.camp).toLowerCase()}|${String(g.code).toLowerCase()}`);
        }
    }

    const hasId = it => it?.id != null && idSet.has(Number(it.id));
    const hasKey = it => {
        if (!it?.camp || !it?.code) return false;
        const key = `${String(it.camp).toLowerCase()}|${String(it.code).toLowerCase()}`;
        return keySet.has(key);
    };

    const isLiked = (item) => {
        if (!item) return false;
        if (match === 'strict') {
            // ต้องตรงทั้ง id และ camp|code
            return hasId(item) && hasKey(item);
        }
        // loose: ตรงอย่างใดอย่างหนึ่งพอ
        return hasId(item) || hasKey(item);
    };

    return { isLiked };
}

export {
    normalizeObjectKeyGameList,
    createLikeIndex
};